export const PartnerDataServiceUrl = {
      createTemplateShellFlag: false,
      partnerTreeUrl() {
            return 'assets/resources/digitizeMenu.json';
      },
      dataIntakeUrl() {
            return 'assets/resources/dataIntakeMenu.json';
      },
      digitizeTreeUrl() {
            return 'assets/resources/digitizeMenu.json';
      },
      defaultPagesTreeUrl() {
            return 'assets/resources/defaultPagesMenu.json';
      },
      CreateRepositoryURL(url) {
            return url + '/api/TFSHelper/CreateRepository'
      },
      GetAll(spName, dbName, url) {
            return url + "/api/" + dbName + "/GetAll?entity=" + spName;
      },
      Post(spName, dbName, url) {
            return url + "/api/" + dbName + "/Post?entity=" + spName;
      },
      GetByColumn(spName, dbName, url) {
            return url + '/api/' + dbName + "/GetByColumn?entity=" + spName;
      },
      Put(spName, dbName, url) {
            return url + "/api/" + dbName + "/Put?entity=" + spName;
      },
      Delete(spName, dbName, url) {
            return url + "/api/" + dbName + "/DeleteByColumn?entity=" +spName;
      },
      RefreshSite(dbName, url) {
            return url + "/api/" + dbName + "/RefreshSite";
      },
      getWorkflowUserRolesUrl() {
            return "/resources/workflowUserRoles.json";
      },
      PostWorkflowData(spName, dbName, url) {
            return url + "/api/" + dbName + "/WorkFlowStageUpdate?entity=" + spName;
      },
      PutWithUdt(entity, attributeEntity, dbName, url) {
            return url + "/api/" + dbName + "/PutWithUdt?entity=" + entity + "&userDefinedTypeEntity=" + attributeEntity;
      },
      UpdateWorkflowStage(entity, attributeEntity, url) {
            return url + "/api/WorkFlow/UpdateWorkflowStage?entity=" + entity + "&userDefinedTypeEntity=" + attributeEntity;
      },
      DiscardWorkflowChanges(serviceWorkflowURL: string) {
            return serviceWorkflowURL + "/api/workflow/DiscardWorkflowChanges?entity=DeltaWF&userDefinedTypeEntity=Entity";
      },
      WorkFlowDataUpdate(entity, attributeEntity, dbName, url) {
            return url + "/api/" + dbName + "/WorkFlowDataUpdate?entity=" + entity + "&userDefinedTypeEntity=" + attributeEntity;
      },
      MoveFilesAndSendEmails(dbName, url) {
            return url + "/api/" + dbName + "/QueueSiteUpdates";
      },
      MoveAllFiles(serviceWorkflowURL: string, dbName) {
            return serviceWorkflowURL + "/api/" + dbName + "/MoveAllFiles";
      },
      StoreDigitalImage(serviceDigitizeURL: string, dbName) {
            return serviceDigitizeURL + "/api/" + dbName + "/StoreDigitalImage";
      },
      GetLinkedStatusForMultipleRecord(spName, dbName, url) {
            return url + "/api/" + dbName + "/GetLinkedStatusForMultipleRecord?entity=" + spName;
      },
      GetLinkedStatusForColumn(spName, dbName, url) {
            return url + "/api/" + dbName + "/GetLinkedStatusForColumn?entity=" + spName;
      },
      PostMultipleUdt(spName, firstUserDefinedTypeEntity, secondUserDefinedTypeEntity, dbName, url) {
            return url + "/api/" + dbName + "/PostMultipleUdt?entity=" + spName + "&firstUserDefinedTypeEntity=" + firstUserDefinedTypeEntity + "&secondUserDefinedTypeEntity=" + secondUserDefinedTypeEntity;
      },
      MoveDataAndFilesToNextPhase(serviceWorkflowURL: string, dbName, partnerSiteGUID, partnerGUID, status, environment, InternalShortName, comments, url) {
            return serviceWorkflowURL + "/api/" + dbName + "/MoveToNextPhase?PartnersiteGUID=" + partnerSiteGUID + "&PartnerGUID=" + partnerGUID + "&status=" + status + "&environment=" + environment + "&InternalShortName=" + InternalShortName + "&comments=" + comments;
      },
      verifyWorkflowLockedFieldStages(serviceWorkflowURL: string, dbName){
            return serviceWorkflowURL + "/api/" + dbName + "/WorkflowVerifyLockedFieldStages"
      },
      getMutipleResultSet(serviceUrl) {
            return serviceUrl + "/api/PartnerData/GetMultipleResultSet";
      }
}

